import * as React from "react";
import Chip from "@warda/library-ui/core/Chip";
const FilterChip = ({ filterId, id, label, tooltip, onClick, color, }) => {
    const onClickChip = React.useCallback((chipId) => {
        onClick(filterId, chipId, label);
    }, [filterId, label, onClick]);
    return (React.createElement(Chip, { id: id, label: label, tooltip: tooltip, onClick: onClickChip, selected: true, icon: "close", color: color }));
};
export default FilterChip;
